import { t } from "ttag";

import { POST_MEETING_STATUS } from "@/features/consultations/models";
import type { Appointment } from "@/features/consultations/models";
import { formatDate, formatTime } from "@/shared/lib";
import { Badge, EmptyState, LinkMinimalistic, TableCard } from "@/shared/ui";

interface PastConsultationsCardsProps {
  consultations: Appointment[];
  setDocumentId: (documentId: Appointment["documentId"]) => void;
}

export const PastConsultationsCards = ({
  consultations,
  setDocumentId,
}: PastConsultationsCardsProps) => {
  if (!consultations.length) {
    return (
      <EmptyState.Root className="md:hidden">
        <EmptyState.Icon />
        <EmptyState.Description>
          {t`You haven't had any consultation yet`}
        </EmptyState.Description>
      </EmptyState.Root>
    );
  }

  return (
    <TableCard.Root>
      {consultations.map((consultation) => (
        <TableCard.Row key={consultation.id}>
          <TableCard.Cell>
            <TableCard.Label>{t`Provider`}</TableCard.Label>
            <TableCard.Data>
              {consultation.provider?.fullName ?? "-"}
            </TableCard.Data>
          </TableCard.Cell>

          <TableCard.Cell>
            <TableCard.Label>{t`Date`}</TableCard.Label>
            <TableCard.Data>
              {formatDate(consultation.startTime)}
            </TableCard.Data>
          </TableCard.Cell>

          <TableCard.Cell>
            <TableCard.Label>{t`Time`}</TableCard.Label>
            <TableCard.Data>
              {formatTime(consultation.startTime)}
            </TableCard.Data>
          </TableCard.Cell>

          <TableCard.Cell>
            <Badge
              size="small"
              color={
                consultation.pmStatus !== POST_MEETING_STATUS.CANCELLED
                  ? "light-secondary"
                  : "red"
              }
            >
              {consultation.pmStatus}
            </Badge>

            {consultation.documentId ? (
              <button
                type="button"
                className="flex items-center justify-end gap-0.5 text-primary-950"
                onClick={() => setDocumentId(consultation.documentId)}
              >
                <LinkMinimalistic className="size-4" />
                <span className="font-medium">{t`Note`}</span>
              </button>
            ) : (
              <TableCard.Data>-</TableCard.Data>
            )}
          </TableCard.Cell>
        </TableCard.Row>
      ))}
    </TableCard.Root>
  );
};
